export const loadFileContentAsString = async <T extends string>(inputfile: Blob): Promise<T> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // Set up event handlers first
        reader.onload = (event) => {
            resolve(event.target!.result as T);
        };
        reader.onerror = (e) => reject(e);
        // Start reading the file
        reader.readAsText(inputfile);
    });
};